/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Button } from 'react-bootstrap';
import './index.css';

export default class PanelGroupForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.params;
  }

  handlePanelOpenAction = (event) => {
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const { handlePanelHead, questionRel } = this.props;
    handlePanelHead && handlePanelHead(questionRel);

    return false;
  };

  handlePanelContinueAction = (event) => {
    event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();

    const { handlePanelContinue, questionRel } = this.props;
    handlePanelContinue && handlePanelContinue(questionRel);

    return false;
  };

  render() {
    const {
      content,
    } = this.props;
    const panelTitleObj = content.panelTitle;
    const panelContinueObj = content.panelContinue;
    const ineditedClass = content.inedited ? 'icon-chevron-right inedited' : 'icon-edit';
    return (
      <div className="panel-group-form">
        <div className="panel-item-head">
          <div data-key={panelTitleObj && panelTitleObj.dataKey} className={'panel-item-title'}>
            {panelTitleObj && panelTitleObj.title}
          </div>
          {!content.isPanel && <div className='panel-icon'>
            {!content.inedited && <i aria-hidden={true} className="icon icon-circle-confirmation-solid panel-done">{}</i>}
            <Button aria-label={'button'} aria-expanded="false" onClick={this.handlePanelOpenAction} bsStyle="link">
              <i aria-hidden={true} className={'icon ' + ineditedClass}>{}</i>
            </Button>
          </div>}

        </div>
         {/*expanded=false :Panel expanded*/}
        <Panel expanded={content.isPanel} defaultExpanded={content.isPanel} collapsible className="panel-item-body">
          {this.props.children}

          <Button className="button-continue btn-info" bsStyle="primary" data-key={panelContinueObj && panelContinueObj.dataKey} onClick={this.handlePanelContinueAction} disabled={false} >
            {panelContinueObj && panelContinueObj.title}
          </Button>
        </Panel>
      </div>
    )
  }
};

PanelGroupForm.propTypes = {
  content: PropTypes.object.isRequired,
  className: PropTypes.string,
  handlePanelContinue: PropTypes.func,
  handlePanelHead: PropTypes.func,
  questionRel: PropTypes.object
};

PanelGroupForm.defaultProps = {
  content: {}
};





// WEBPACK FOOTER //
// ./src/shared/AOForm/components/PanelGroup/index.js